import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import { Link, Icon } from '..';
import { ModalContext } from './ModalContext';

const { useContext } = React;

export interface Props extends FlexProps {
  /**
   * Flag to toggle the gradient separator
   */
  withSeparator?: boolean;
}

/**
 * Modal header wrapper with optional gradient separator.
 */
const ModalHeader: React.FunctionComponent<Props> = (props: Props) => {
  const {
    withSeparator,
    children,
    padding,
    paddingHorizontal = padding,
    paddingVertical = padding,
    ...rest
  } = props;
  const { onClose } = useContext(ModalContext);

  const classes = classnames('ModalHeader', {
    'ModalHeader--with-separator': withSeparator,
  });

  return (
    <Flex { ...rest }
        className={ classes }
        direction="horizontal">
      <Flex
          grow
          initial="none"
          paddingHorizontal={ paddingHorizontal }
          paddingVertical={ paddingVertical }>
        { children }
      </Flex>
      <Flex padding="x4">
        <Link
            clickable
            color="grape-5"
            onClick={ onClose }>
          <Icon name="CloseSmall" />
        </Link>
      </Flex>
    </Flex>
  );
};

ModalHeader.defaultProps = {
  padding: 'x6',
  gap: 'x2',
};

export default ModalHeader;
